// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aV-S","footer":"styles_footer__dndb9"};